module.exports = __webpack_public_path__ + "img/hexagon-02.65507fa7.svg";